import React from "react";
import { Stack, Box } from "@mui/material";
import MKTypography from "components/MKTypography";
import HeaderContainer from "styles/components/headerContainer";
import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import { StyledHowToCard } from "index.styles";
import theme from "assets/theme";
import useMediaQueries from "utils/mediaQueries.utils";

const AfterYourSession = ({ title, highlightText, intro, cards = [], closing }) => {
  const { isLg } = useMediaQueries();

  return (
    <StyledSectionContainer component="section" id="after-your-session-section">
      <HeaderContainer
        textColor={theme.palette.primary.main}
        highlightColor={theme.palette.accent.main}
        component="h2"
        variant="h2"
        title={title}
        highlightText={highlightText}
        cssProps={{ margin: "0 0 1rem 0", textAlign: "center" }}
      />
      {intro && (
        <MKTypography component="p" variant={isLg ? "body1" : "body2"} sx={{ marginBottom: "2rem", textAlign: "center" }}>
          {intro}
        </MKTypography>
      )}

      <Stack spacing={"1.5rem"}>
        {cards.map(({ leadIn, body }, index) => (
          <StyledHowToCard key={index}>
            <MKTypography component="p" variant={isLg ? "body1" : "body2"}>
              <Box component="span" sx={{ fontWeight: 700 }}>
                {leadIn}
              </Box>{" "}
              {body}
            </MKTypography>
          </StyledHowToCard>
        ))}
      </Stack>

      {closing && (
        <MKTypography component="p" variant={isLg ? "body1" : "body2"} sx={{ marginTop: "2rem", textAlign: "center" }}>
          {closing}
        </MKTypography>
      )}
    </StyledSectionContainer>
  );
};

export default AfterYourSession;
